(function () {
    'use strict';

    angular
        .module('elogbooks.admin.users')
        .controller('UserPasswordResetModalController', UserPasswordResetModalController);

    UserPasswordResetModalController.$inject = ['$uibModalInstance', 'userResource', 'apiClient', 'messenger', 'elbSettings', '$timeout'];

    function UserPasswordResetModalController ($uibModalInstance, userResource, apiClient, messenger, elbSettings, $timeout) {
        var vm = this;

        // Initialize validation state
        vm.passwordMatch = true; // Start as true to hide error initially
        vm.passwordValid = false;
        vm.generatedPassword = null;
        vm.showPassword = false;
        vm.isSubmitting = false; // Track submission state
        vm.password = {
            new: null,
            repeated: null
        };
        vm.passwordReset = false;

        // Get password settings
        vm.passwordSettings = {
            minLength: elbSettings.getSetting('password_min_characters', 8).value,
            requireUppercase: elbSettings.getSetting('password_require_uppercase', false).value,
            requireNumber: elbSettings.getSetting('password_require_number', false).value,
            requirePunctuation: elbSettings.getSetting('password_require_punctuation', false).value
        };

        vm.validatePassword = function() {
            // Check password match
            vm.passwordMatch = true;
            if (vm.password.new && vm.password.repeated && vm.password.new !== vm.password.repeated) {
                vm.passwordMatch = false;
            }

            // Check if all requirements are met
            if (!vm.password.new || !vm.password.repeated || !vm.passwordMatch) {
                vm.passwordValid = false;
                return false;
            }

            var isValid = true;

            // Check minimum length
            if (vm.passwordSettings.minLength > 0 && !vm.hasMinLength()) {
                isValid = false;
            }

            // Check uppercase requirement
            if (vm.passwordSettings.requireUppercase && !vm.hasUppercase()) {
                isValid = false;
            }

            // Check number requirement
            if (vm.passwordSettings.requireNumber && !vm.hasNumber()) {
                isValid = false;
            }

            // Check punctuation requirement
            if (vm.passwordSettings.requirePunctuation && !vm.hasPunctuation()) {
                isValid = false;
            }

            vm.passwordValid = isValid;
            return isValid;
        };

        // Helper functions for template validation
        vm.hasUppercase = function() {
            return vm.password.new && /[A-Z]/.test(vm.password.new);
        };

        vm.hasNumber = function() {
            return vm.password.new && /[0-9]/.test(vm.password.new);
        };

        vm.hasPunctuation = function() {
            return vm.password.new && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(vm.password.new);
        };

        vm.hasMinLength = function() {
            return vm.password.new && vm.password.new.length >= vm.passwordSettings.minLength;
        };

        // Legacy function for backward compatibility
        vm.passwordsMatch = function() {
            return vm.validatePassword();
        };

        vm.change = function () {
            // Validate password before submitting
            if (vm.validatePassword() && !vm.isSubmitting) {
                vm.isSubmitting = true;
                
                apiClient.update(userResource.getLink('change-password'), {
                    password: vm.password.new,
                }).then(function (response) {
                    vm.isSubmitting = false;
                    
                    if (response) {
                        messenger.success('PASSWORD_CHANGED');
                        $uibModalInstance.close('passwordChanged');
                    } else {
                        messenger.error('REQUEST_ERROR');
                    }
                }, function(error) {
                    // Handle error and re-enable button
                    vm.isSubmitting = false;
                    messenger.error('REQUEST_ERROR');
                });
            }
        };

        vm.reset = function () {
            apiClient.create(userResource.getLink('passwordreset')).then(function (response) {
                vm.generatedPassword = response.password;
                vm.passwordReset = true;
            });
        }

        vm.close = function () {
            if (vm.passwordReset) {
                $uibModalInstance.close('passwordReset');
            } else {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();